async function getChecksumWord(words: string[], wordList: string[]) {
  const seed = words.join('-');
  const checksumHash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(seed));
  const checksumArray = new Uint8Array(checksumHash);
  let checksum = 0n;
  for (const byte of checksumArray) {
    checksum = (checksum << 8n) | BigInt(byte);
  }
  const checksumIndex = checksum % BigInt(wordList.length);
  return wordList[Number(checksumIndex)];
}

export class DicewarePassphrase {
  constructor(
    readonly wordList: string[],
    readonly words: string[],
    readonly checksumWord: string,
  ) {}

  async hasValidChecksum() {
    const checksumWord = await getChecksumWord(this.words, this.wordList);
    return this.checksumWord === checksumWord;
  }

  toString() {
    return [...this.words, this.checksumWord].join('-');
  }

  static async fromRandom(wordList: string[], wordCount: number = 6, next: (max: number) => number = secureRandomInt) {
    if (wordCount < 1 || wordCount > wordList.length) {
      throw new Error(`wordCount must be between 1 and ${wordList.length}`);
    }

    const words = [];
    for (let i = 0; i < wordCount; i++) {
      const randomIndex = next(wordList.length);
      words.push(wordList[randomIndex]);
    }

    const checksumWord = await getChecksumWord(words, wordList);

    return new DicewarePassphrase(
      wordList,
      words,
      checksumWord,
    );
  }
}

function secureRandomInt(max: number) {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] % max;
}
